module.exports = __webpack_public_path__ + "img/transport-1-stop.701e2dc2.svg";